// extracted by mini-css-extract-plugin
export default {"page_not_found":"page-not-found_page_not_found__3HtoX","wrapper":"page-not-found_wrapper__20ZB1","container":"page-not-found_container__TwlTl"};